// dashboardThunks.js
import apiClient from "@/services/api/apiClient";
import {
  addProjects,
  addFolders,
  addFiles,
  setSelectedProjectId,
  setSelectedFolderId,
  setSeletedFileId,
  addSentences,
  addManageUsers,
  refreshFiles,
  setCompletedFiles,
  setCompletedProjects,
  setCompletedFolders,
} from "@store/slices/dashboardSlice";

import { BASE_URL, DEVNAGRI_ID, GAADMIN_ID, ROLE_ROUTES } from "@utils/constants";

// Thunk to fetch all projects
export const fetchAllProjects = (activeTab, keyword = '', page = 0, size = 10,navigate) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { userId, isAuthenticated, token } = state.auth;

    if (isAuthenticated) {
      console.log(token)
      const url = activeTab === 'GA' ? `${BASE_URL}api/superAdmin/project/GS?userId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}` :
        `${BASE_URL}api/superAdmin/project/Dev?userId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}`
      console.log(url)

      const data = await apiClient(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        credentials: "include",
      },navigate);

      dispatch(addProjects(data.data));
      return data; // Optional: return data if you need it elsewhere
    }
  } catch (error) {
    console.error("Error fetching projects:", error);
    return { success: false, error: error.message };
  }
};

// Thunk to fetch folders for a specific project
export const fetchFolderDetails = (activeTab, projectId, keyword = '', page = 0, size = 10,navigate) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { token } = state.auth;
    // First set the selected project ID
    dispatch(setSelectedProjectId(projectId));

    // Then fetch the folders
    const url = activeTab === 'GA' ? `${BASE_URL}api/superAdmin/folder/GS?projectId=${projectId}&searchKeyword=${keyword}&page=${page}&size=${size}` :
      `${BASE_URL}api/superAdmin/folder/Dev?projectId=${projectId}&searchKeyword=${keyword}&page=${page}&size=${size}`
    const data = await apiClient(url, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      }
    },navigate);

    // Finally add the folders to the store
    console.log("folders------------->", data.data);
    dispatch(addFolders(data.data));
    return { success: true, data: data.data };
  } catch (error) {
    console.error("Error fetching folders:", error);
    return { success: false, error: error.message };
  }
};

// Thunk to fetch files for a specific folder
export const fetchFoldersInfo = (activeTab, folderId, keyword = '', page = 0, size = 10,navigate) => async (dispatch, getState) => {
  try {
    // First set the selected folder ID if not already set
    const state = getState();
    const currentFolderId = state.dashboard.selectedFolderId;

    if (currentFolderId !== folderId) {
      dispatch(setSelectedFolderId(folderId));
    }

    // Signal that we're refreshing files for this folder
    dispatch(refreshFiles(folderId));

    const url = activeTab === 'GA' ? `${BASE_URL}api/superAdmin/file/GS?folderId=${folderId}&searchKeyword=${keyword}&page=${page}&size=${size}` :
      `${BASE_URL}api/superAdmin/file/Dev?folderId=${folderId}&searchKeyword=${keyword}&page=${page}&size=${size}`

    // Then fetch the files
    const data = await apiClient(url, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${state.auth.token}`
      }
    },navigate);


    // Finally add the files to the store
    dispatch(addFiles(data.data));
    return { success: true, data: data.data };
  } catch (error) {
    console.error("Error fetching files:", error);
    return { success: false, error: error.message };
  }
};

export const fetchSentences = (activetab, fileId, clickReject = false, targetId = null,navigate) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    dispatch(setSeletedFileId(fileId));
    const url = activetab === 'GA' ? (!clickReject ? `${BASE_URL}api/superAdmin/gsApprovedSentences?fileId=${fileId}` :
      `${BASE_URL}api/superAdmin/gsRejectedSentences?fileId=${fileId}`) : (!clickReject ? `${BASE_URL}api/superAdmin/devApprovedSentences?fileId=${fileId}&sourceId=2&targetId=${targetId}` :
        `${BASE_URL}api/superAdmin/gsRejectedSentences?fileId=${fileId}`);

    const data = await apiClient(
      url,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
      ,navigate
    );

    console.log("Sentencesss------------>", data);
    dispatch(addSentences(data.data));
    return data;
  } catch (error) {
    console.error("Error fetching files:", error);
  }
};

export const fetchCompletedProjects = (activeTab, keyword = '', page = 0, size = 10,navigate) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const url = activeTab === 'GA' ? `${BASE_URL}api/superAdmin/gsCompletedProjects?searchKeyword=${keyword}&page=${page}&size=${size}` :
      `${BASE_URL}api/superAdmin/devCompletedProjects?searchKeyword=${keyword}&page=${page}&size=${size}`;

    const data = await apiClient(
      url,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      },navigate
    );

    console.log("Completed Projects------------>", data);
    dispatch(setCompletedProjects(data.data));
    return data;
  } catch (error) {
    console.error("Error fetching projects:", error);
  }
};

export const fetchCompletedFolders = (activeTab, projectId, keyword = '', page = 0, size = 10,navigate) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const url = activeTab === 'GA' ? `${BASE_URL}api/superAdmin/folder/GS?projectId=${projectId}&searchKeyword=${keyword}&page=${page}&size=${size}` :
      `${BASE_URL}api/superAdmin/devCompletedFolders?projectId=${projectId}&searchKeyword=${keyword}&page=${page}&size=${size}`;

    const data = await apiClient(
      url,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      },navigate
    );

    console.log("Completed Folders------------>", data);
    dispatch(setCompletedFolders(data.data));
    return data;
  } catch (error) {
    console.error("Error fetching folders:", error);
  }
};

export const fetchCompletedFiles = (activeTab, folderId, keyword = '', page = 0, size = 10,navigate) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const url = activeTab === 'GA' ? `${BASE_URL}api/superAdmin/gsCompletedFiles?folderId=${folderId}&searchKeyword=${keyword}&page=${page}&size=${size}` :
      `${BASE_URL}api/superAdmin/devCompletedFiles?folderId=${folderId}&searchKeyword=${keyword}&page=${page}&size=${size}`;

    const data = await apiClient(
      url,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      },navigate
    );

    console.log("Completed Files------------>", data);
    dispatch(setCompletedFiles(data.data));
    return data;
  } catch (error) {
    console.error("Error fetching files:", error);
  }
};

export const fetchCompletedSentences = (activeTab, fileId, targetId, clickReject,navigate) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    dispatch(setSeletedFileId(fileId));
    const url =
      activeTab === 'GA'
        ? clickReject
          ? `${BASE_URL}api/superAdmin/gsCRSentences?fileId=${fileId}&sourceId=2&targetId=${targetId}`
          : `${BASE_URL}api/superAdmin/gsCASentences?fileId=${fileId}&sourceId=2&targetId=${targetId}`
        : clickReject
          ? `${BASE_URL}api/superAdmin/devCRSentences?fileId=${fileId}&sourceId=2&targetId=${targetId}`
          : `${BASE_URL}api/superAdmin/devCASentences?fileId=${fileId}&sourceId=2&targetId=${targetId}`;

    const data = await apiClient(
      url,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      },navigate
    );

    console.log("completed Sentencesss------------>", data);
    dispatch(addSentences(data.data));
    return data;
  } catch (error) {
    console.error("Error fetching sentences:", error);
  }
};


export const assignFiles = (activetab, fileId) => async (dispatch, getState) => {
  try {
    dispatch({ type: "ASSIGN_FILES_REQUEST" });

    const state = getState();
    const token = state.auth.token;
    const selectedFolderId = state.dashboard.selectedFolderId;

    // Get the files data to find the specific file's language information
    const files = state.dashboard.files;
    const fileArray = files[selectedFolderId] || [];
    const fileData = fileArray.find(file => file.fileId === parseInt(fileId) || file.fileId === fileId);

    console.log("File data for assignment:", fileData);

    // Construct the URL based on the active tab
    let url;
    if (activetab === 'GA') {
      url = `${BASE_URL}api/superAdmin/assignGS?userId=${GAADMIN_ID}&fileId=${fileId}`;
    } else {
      // For Devnagri, include source and target language IDs
      url = `${BASE_URL}api/superAdmin/assignDev?userId=${DEVNAGRI_ID}&fileId=${fileId}`;

      // Add source language ID (default to 2 if not in file data)
      const sourceLanguageId = fileData?.sourceId;
      url += `&sourceLanguageId=${sourceLanguageId}`;

      // Add target language ID (default to 1 if not in file data)
      // Target language ID should be in the file data from the API
      const targetLanguageId = fileData?.targetId ;
      url += `&targetLanguageId=${targetLanguageId}`;
    }

    console.log(`Making assignment API call to: ${url}`);

    const data = await apiClient(url, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });

    console.log("Assignment API response:", data);

    // Refresh the file list after assignment
    if (selectedFolderId) {
      await dispatch(fetchFoldersInfo(activetab, selectedFolderId));
    }

    return { success: true, data };
  } catch (error) {
    console.error("Assignment error:", error);
    dispatch({
      type: "ASSIGN_FILES_FAILURE",
      payload: error.message,
    });

    throw error;
  }
};

export const assignFilesToDevnagriValidatorAdmin = (fileIds, folderId, fileId, roleId) => async (dispatch, getState) => {
  try {
    dispatch({ type: "ASSIGN_FILES_REQUEST" });
    const state = getState();
    const activetab = state.dashboard.activetab;

    const data = await apiClient(
      BASE_URL + "api/admin/assignFilesToDevnagriValidator",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${state.auth.token}`
        },
        body: JSON.stringify({ fileIds }),
      }
    );

    dispatch(fetchFoldersInfo(activetab, folderId));
    dispatch(fetchSentences(activetab, fileId));
    dispatch({
      type: "ASSIGN_FILES_SUCCESS",
      payload: data,
    });

    return data;
  } catch (error) {
    dispatch({
      type: "ASSIGN_FILES_FAILURE",
      payload: error.message,
    });

    throw error;
  }
};

const convertToLocalDateTime = (dateStr) => {
  return `${dateStr}T00:00:00`;
};

export const createProject = (activeTab, projectDetails) => async (dispatch, getState) => {
  try {
    const state = getState();
    console.log(state)
    const userId = state.auth.userId;
    console.log(userId)
    const reqBody = {
      projectName: projectDetails.projectName,
      description: projectDetails.description,
      createdBy: userId,
      createdFor: activeTab === 'GA' ? GAADMIN_ID : DEVNAGRI_ID,    //2 for GAAdmin
      deadline: convertToLocalDateTime(projectDetails.deadline),
    };
    const url = activeTab === 'GA' ? `${BASE_URL}api/superAdmin/project/createForGS` : `${BASE_URL}api/superAdmin/project/createForDev`
    const data = await apiClient(
      // {{url}}/api/superAdmin/project/create
      url,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${state.auth.token}`
        },
        body: JSON.stringify({ ...reqBody }),
      });
    dispatch(fetchAllProjects(activeTab));
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const deleteProject = (activetab, projectId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { userId, token } = state.auth;
    const url = activetab === 'GA' ? `${BASE_URL}api/superAdmin/project/delete/GS?projectId=${projectId}&userId=${userId}` : `${BASE_URL}api/superAdmin/project/delete/Dev?projectId=${projectId}&userId=${userId}`
    const data = await apiClient(url, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
    });

    // if (!response.ok) {
    //   throw new Error(`Server responded with status: ${response.status}`);
    // }
    dispatch(fetchAllProjects(activetab));
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const createFolder = (activeTab, folderDetails) => async (dispatch, getState) => {
  try {
    console.log(folderDetails)
    const state = getState();
    const { token } = state.auth;

    const reqBody = {
      projectId: folderDetails.projectDetailsId,
      folderName: folderDetails.folderName,
      createdBy: state.auth.userId,
    };
    const url = activeTab === 'GA' ? `${BASE_URL}api/superAdmin/folder/create/GS` : `${BASE_URL}api/superAdmin/folder/create/Dev`
    const data = await apiClient(
      url,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ ...reqBody }),
      }
    );

    dispatch(fetchFolderDetails(activeTab, folderDetails.projectDetailsId));
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const deleteFolder = (activetab, folderId, projectId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { userId, token } = state.auth;
    const url = activetab === 'GA' ? `${BASE_URL}api/superAdmin/folder/delete/GS?folderId=${folderId}&userId=${userId}` : `${BASE_URL}api/superAdmin/folder/delete/Dev?folderId=${folderId}&userId=${userId}`
    const data = await apiClient(
      url,
      {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );

    dispatch(fetchFolderDetails(projectId));
  } catch (error) {
    return error;
  }
};

export const assignSentences = (sentencesIds, fileId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const activetab = state.dashboard.activetab;

    const data = await apiClient(
      BASE_URL + "api/admin/assignSentencesToTranslatorAdmin",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ sentencesIds }),
      }
    );


    dispatch(fetchSentences(activetab, fileId));


    return data;
  } catch (error) {
    return error;
  }
};

export const deleteFile = (activetab, fileId, folderId) => async (dispatch) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const response = await apiClient(`${BASE_URL}api/files/deleteFile/${fileId}`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      }
    });

    dispatch(fetchFoldersInfo(folderId));
  } catch (error) {
    return error;
  }
};

export const fetchAllUsers = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const data = await apiClient(
      BASE_URL + `api/superAdmin/pending`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    console.log("All pending users data:", data);
    if (data.message == "No users found for status: PENDING") {
      console.log("No users found for status: PENDING");
      dispatch(addManageUsers([])); // Dispatch empty array if no users found
      return;
    }
    dispatch(addManageUsers(data.data));
    return data;
  } catch (error) {
    console.error("Error fetching Users:", error);
  }
};

export const updateUserStatus = (userId, status) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const response = await apiClient(
      BASE_URL + `api/superAdmin/activate/${userId}`,
      {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    dispatch(fetchAllUsers());
  } catch (error) {
    console.log("Error fetching projects:", error);
  }
};

export const fetchCountAllProjects = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    console.log(token)
    const data = await apiClient(
      BASE_URL + `api/superAdmin/statistics`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    return data.data;
  } catch (error) {
    console.log("Error fetching projects:", error);
  }
}



export const sendToDevnagri = (fileId, sourceLanguageId, targetLanguageId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const payload = {
      fileId,
      sourceLanguageId,
      targetLanguageId
    }


    const data = await apiClient(
      BASE_URL + `api/superAdmin/sendToDev`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload)
      }
    );
    console.log(`send to devnagri`, data);
    return data;
  } catch (error) {
    console.log("Error fetching files:", error);
    return error;
  }
}


